import { Container } from './styled';
function VisuallyHidden(props) {
    const { children } = props;
    return <Container>{children}</Container>;
}
export default VisuallyHidden;
